import { graphql } from "@/api/graphql/types/gql";

export const createTidLinkedAccountMutation = graphql(`
  mutation CreateTidLinkedAccount(
    $request: BillingMsCreateTidLinkedAccountRequest!
  ) {
    BillingMsCreateTidLinkedAccount(request: $request) {
      id
    }
  }
`);
